import _ from 'lodash';

export const getPolicyDocuments = (state) => _.get(state, 'policy.documents');

export const getPolicyFetching = (state) => _.get(state, 'policy.fetching');

export const getLastPolicyDocument = (state) => _.get(state, 'policy.documents[0]');
